"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResultsActiveItem = void 0;
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const ResultsProvider_1 = require("../containers/ResultsProvider");
const useResultsActiveItem = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const resultsCountersIdsList = (0, react_redux_1.useSelector)(ResultsProvider_1.selectResultCountersIdsList);
    const currentSportId = (0, react_redux_1.useSelector)(ResultsProvider_1.selectResultsFilterSportId);
    const includesSportId = resultsCountersIdsList.includes(currentSportId);
    (0, react_1.useEffect)(() => {
        if (!includesSportId && resultsCountersIdsList.length > 0) {
            dispatch(ResultsProvider_1.resultsProviderActions.setCurrentSportIdFilter({
                sportId: resultsCountersIdsList[0],
            }));
        }
    }, [dispatch, resultsCountersIdsList, currentSportId, includesSportId]);
};
exports.useResultsActiveItem = useResultsActiveItem;
//# sourceMappingURL=useResultsActiveItem.js.map